// extracted by mini-css-extract-plugin
export default {"container":"CardByArea_container__JkDE2","location":"CardByArea_location__0wap4","numOfListings":"CardByArea_numOfListings__hq6Pw"};